(function($) {
  function collectionSortBy() {
    $(document).on('change', '.sort_by', function(e) {
      console.log(e);
      e.preventDefault();
      e.stopPropagation();
      
      var $target = $(e.currentTarget);
      var sort_value = $target.val();
      window.location.href = window.location.pathname + '?sort_by=' + sort_value;
    });
  }
  
  $(document).ready(function() {
    collectionSortBy();
    console.log('READY');
  });
})(jQuery);